export default __webpack_public_path__ + "static/ico-ai-6dbbe793b2dedaa0004376548325ce7f.svg";